export class SearchesService {
	constructor($http, $q, $timeout) {
		'ngInject';
		this.$http = $http;
		this.$q = $q;
		this.$timeout = $timeout;
		this.publicRoot = '/public';
		this.privateRoot = '/private';
	}

	checkExistance(params) {
		return this.$http({
			method: 'GET',
			url: `${this.privateRoot}/searches/find-by-url`,
			params
		});
	}

	saveSearch(params) {
		return this.$http({
			method: 'POST',
			url: `${this.privateRoot}/searches`,
			data: params
		});
	}

	getSavedSearches(params) {
		return this.$http({
			method: 'GET',
			url: `${this.privateRoot}/searches`,
			params: params
		});
	}

	renameSearch(id, data) {
		return this.$http({
			method: 'PUT',
			url: `${this.privateRoot}/searches/${id}`,
			data: data
		});
	}

	deleteSearch(id) {
		if (typeof  id != "undefined") {
			return this.$http({
				method: 'DELETE',
				url: `${this.privateRoot}/searches/${id}`
			});
		} else {
			return this.$http({
				method: 'DELETE',
				url: `${this.privateRoot}/searches`
			});
		}
	}
}
